
import { defineComponent } from 'vue';
import ReturnOptions from '@/components/ReturnOptions.vue';

export default defineComponent({
    components: {
        ReturnOptions,
    },
    props: {
        trailerNumber: {
            type: String,
            required: true,
        },
    },
});
